import { nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import parse2query from './util/parse2query'
import formatParams from './util/formatParams'

interface INavigate {
  url: string
  options?: object
}

function resolvePath(url: string, params: object) {
  return parse2query(params) ? `${url}?${parse2query(params)}` : url
}

/**
 * 以webview容器的方式，跳转到应用内的某个页面
 * @param url 路径后可以带参数。参数与路径之间使用 ? 分隔，参数键与参数值用 = 相连，不同参数用 & 分隔；如 'path?key=value&key2=value2'
 * @param options gmu 跳转参数，如navBarType=1 等，参照 http://document.lightyy.com/zh-cn/api/olight-route.html#%E8%B7%AF%E7%94%B1%E8%B7%B3%E8%BD%AC 里的 options 说明
 */
function navigateTo({ url = '', options = {} }: INavigate) {
  let newUrl = 'gmu://web?startPage=' + encodeURIComponent(`${url}`)
  let formatOptions = parse2query(options)
  if (formatOptions) {
    newUrl += `&${formatOptions}`
  }

  window.location.href = newUrl
}

/**
 * 导航
 *
 * @param {string} url
 * 支持类型<br>
 * 1，https://www.baidu.com<br>
 * 2，http://www.baidu.com<br>
 * 3，native://1-20<br>
 * 4，native://1-62?login_flag=1<br>
 * 5，gmu://web?startPage=fans.vhost.light.com/index.html<br>
 */
function navigate(url: string) {
  if (/^(gmu:\/\/)/.test(url)) {
    window.location.href = url
  }
  // 投资赢家协议头
  if (/^(native:\/\/)/.test(url) || /(http|https):\/\/([\w.]+\/?)\S*/.test(url)) {
    const params = formatParams({
      funType: 'forward',
      funName: 'forwardPage',
      pageUrl: url
    })
    const opts: IBridgeOptions = {
      method: 'winner.hsJsFunction',
      params
    }
    try {
      nativeJSBridgeSync(opts)
    } catch (err) {
      console.error('调用 navigate 发生异常')
    }
  }
}

export { navigateTo, navigate }
